"use client";

import { useEffect, useState } from "react";
import VegaEmbed from "@/components/VegaEmbed";
import { getRelatedItems } from "./Algorithm";
import { getMapItem } from "./Algorithm";
import { Button } from "./ui/button";
import * as XLSX from "xlsx";

export default function Chart(props: any) {
  
  let { filename, filter, colorValues} = props;

  let [mode, setMode] = useState("Chart");
  let [chartData, setChartData] = useState<any[]>([]);
  let [forExcel, setForExcel] = useState<any[]>([]);
  let [spec, setSpec] = useState<any>(null);
  let [dimList, setDimList] = useState<string[]>([]);
  let [mapItem, setMapItem] = useState(getMapItem(filename, filter));

  useEffect(() => {
    if (!props.duckLoaded) return console.log("No duck");

    let getChartData = async () => {
      let dimList_ = [mapItem[1]];
      if (mapItem[2]) dimList_.push(mapItem[2]);
      let fl = mapItem[3] ? [mapItem[3].replaceAll("/", "_")
                                       .replaceAll("@", "_")
                                       .replaceAll(".", "_")
                                       .replaceAll(" ", "_")] 
                          : null;
      if (fl && mapItem[4]) fl.push(mapItem[4].replaceAll("/", "_")
                                              .replaceAll("@", "_")
                                              .replaceAll(".", "_")
                                              .replaceAll(" ", "_"));

      setDimList([...dimList_]);
      let part1 = dimList_.join("__");
      let part2 = "." + mapItem[0];
      let part3 = fl ? ("." + fl.join("__")) : "";
      let fname = `${part1}${part2}${part3}`;

      props.onEvent({message: "GetChartData", params: {
        filename: decodeURIComponent(fname || ""),
        datasetId: props.datasetId, 
        dimList: dimList_, 
        prefix: props.prefix || "",
        agg: mapItem[0], 
        setData: setChartData,
        setForExcel: setForExcel,
        setSpec: setSpec,
      }});
    }
    getChartData();
  }, [mapItem, props.duckLoaded]);

  const downloadExcel = () => {
    let workbook = XLSX.utils.book_new();
    workbook.SheetNames.push("Data");
    const sheet = XLSX.utils.aoa_to_sheet(forExcel);
    workbook.Sheets["Data"] = sheet;
    XLSX.writeFile(workbook, filename + ".xlsx", { bookType: "xlsx", type: "buffer" });
  }

  const setMapItemAtIndex = (value: string, index: number) => {
    let mapItem_ = mapItem.map((item: string, i: number) => i === index ? value : item);
    setMapItem(mapItem_);
  }

  let timeDim = () => {
    return ["ymd", "ym", "y"].includes(dimList[0]) || spec?.[dimList[0]]?.dim_type == 'time'
  }

  let agg = mapItem[0];
  
  let vegaSpec: any = {
    data: {values: chartData},
    title: "",
      // `${agg} by ${dimList.join(", ")} filter ${mapItem[3] || ""} ${mapItem[4] || ""}`,
    width: props.width * 0.6,
    height: props.height * 0.5,
    encoding: {
      x: { 
        field: dimList[0], 
        type: "ordinal", 
        sort: timeDim() ? { field: dimList[0], order: "ascending"} 
              : { op: "sum", field: agg, order: "descending" }
      },
      y: { 
        field: agg, 
        type: "quantitative",
        // sort: { field: agg, order: 'descending' },
      },
    },
    layer: [ 
      {
        mark: "bar",
        encoding: {
          ...(dimList.length < 2 ? {} 
              : {
                  color: {field: dimList[1]},
                  tooltip: [{field: dimList[1], type: "nominal"}, {field: agg, type: "quantitative"},]
                }),
          ...(colorValues?.length > 0 ? { scale: { domain: colorValues } }: {}), 
        },
      },
      ...(agg?.includes('__diff') ? [] : [
      {
        mark: {
          type: "text", dy: -5,
          fontWeight: "bold",
          fontSize: 12,
          color: "black"
        },
        encoding: {
          text: { aggregate: "sum", field: agg, type: "quantitative" },
          y: { aggregate: "sum", field: agg, type: "quantitative" },
        },
      }])
    ]
  }
  if (agg?.includes("__diff")) {
    vegaSpec.encoding.xOffset = { field: dimList[1] };
  } else if (!agg?.includes("__diff") && dimList.length >= 2) {
    if (spec?.[dimList[1]]?.status) {
      vegaSpec.layer[0].encoding.order = { field: dimList[1], sort: "asscending"}
    } else { 
      vegaSpec.layer[0].encoding.order = { field: agg, sort: "descending"}
    }
  }

  let s = getRelatedItems(mapItem, props.previewItems);
  console.log('s props.previewItems: ', props.previewItems);
  console.log('s mapItem: ', mapItem);
  console.log('s: ', s);

  // let query = { 
  //   datasetId: props.datasetId,
  //   selecconsole.log();tedTab: props.selectedTab,
  // }
  //
  // let F = filter?.split("__")
  //   .reduce((acc: any[], cur: string, index: number) => {
  //     if (index % 2 === 0) {
  //       acc.push(`${cur}__`);
  //     } else {
  //       acc[acc.length - 1] = acc[acc.length - 1] + cur;
  //     }
  //     return acc;
  //   }, []);

  return(
    <div>
      {!props.showChart &&
      <div
        style={{backgroundColor: "lightblue", marginRight: "10px", cursor: "pointer"}}
        onClick={(e: any) => { 
          props.setState({dimList: [], filter: null, colorValues: null});
          // globalThis.history.pushState({}, "", `/chart/?` + (new URLSearchParams(query)).toString());
        }}>
        &lt;&lt;Preview
      </div>}
      <div>
      <select className="border" value={mapItem[0] || ""} 
        onChange={(e: any) => {
          setMapItemAtIndex(e.target.value === "" ? null : e.target.value, 0)
        }}
        >
        {s[0].map((item: any, index: number) => (
        <option key={index} value={item || ""}>{item === null ? "null" : item}</option>
        ))}
      </select>
      </div>
      <div className="grid grid-cols-2">
        <select className="border" value={mapItem[1] || ""} 
          onChange={(e: any) => {
            setMapItemAtIndex(e.target.value === "" ? null : e.target.value, 1)
          }}
          >
          {s[1].map((item: any, index: number) => (
          <option key={index} value={item || ""}>{item === null ? "null" : item}</option>
          ))}
        </select>
        <select className="border" value={mapItem[2] || ""} 
          onChange={(e: any) => {
            console.log(e.target.value);
            setMapItemAtIndex(e.target.value === "" ? null : e.target.value, 2)
          }}
          >
          {s[2].map((item: any, index: number) => (
          <option key={index} value={item || ""}>{item === null ? "null" : item}</option>
          ))}
        </select>
        <select className="border" value={mapItem[3] || ""} 
          onChange={(e: any) => {
            setMapItemAtIndex(e.target.value === "" ? null : e.target.value, 3)
          }}
          >
          {s[3].map((item: any, index: number) => (
          <option key={index} value={item || ""}>{item === null ? "null" : item}</option>
          ))}
        </select>
        <select className="border" value={mapItem[4] || ""} 
          onChange={(e: any) => {
            setMapItemAtIndex(e.target.value === "" ? null : e.target.value, 4)
          }}
          >
          {s[4].map((item: any, index: number) => (
          <option key={index} value={item || ""}>{item === null ? "null" : item}</option>
          ))}
        </select>
      </div>
      {/*
      <div 
        style={{
          display: "flex", 
          justifyContent: "flex-end",
          borderBottom: "solid grey 1px"
        }}>
        <MenuItem mode={mode} name="Chart" setMode={setMode} />
        <MenuItem mode={mode} name="Table" setMode={setMode} />
      </div>
      */}
      {mode === "Chart" && dimList.length > 0 ?
      <>
        <VegaEmbed
          data={vegaSpec}
        />
        <Button
          className="mr-2 bg-blue-500 hover:bg-blue-600 active:bg-blue-700 text-white transition-colors"
          onClick={(e: any) => {
            downloadExcel();
          }}>
          Download Excel
        </Button>
      </>
      
      : mode === "Table" && dimList.length > 0 ?
      <div style={{height: "800px", overflowY: "auto"}}>
      {chartData.map((item: any, index: number) => (
        <div 
          key={index} 
          style={{
            display: "flex", width: "300px", fontFamily: "lucida console",
          }}>
          <div style={{flex: 1}}>
            {item.created_ym}
          </div>
          <div style={{flex: 1, textAlign: "right"}}>
            {item.id__count}
          </div>
        </div>
      ))}
      </div>

      : <></>
    }
    </div>
  )
}

function MenuItem(props: any) {
  return (
    <div
      style={{
        cursor: "pointer", padding: "0 5px 0 5px",
        backgroundColor: props.name === props.mode ? "lightblue" : "white"
      }}
      onClick={(e: any) => {
        props.setMode(props.name)
      }}>
      {props.name}
    </div>
  )
}
